import React, { useState, useEffect } from 'react';
import { Button, Col, Row, ModalBody, Form, Spinner } from 'reactstrap';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';

//redux
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { addNewWaterSource, checkWaterSourceExists, updateWaterSource } from '../../../../../slices/waterSource/thunk';
import { setRequireCloseModal } from '../../../../../slices/waterSource/reducer';
import OInput from '../../../../../Components/OElements/OInput';
import OSelect from '../../../../../Components/OElements/OSelect';
import { getRegionList } from '../../../../../helpers/establishment/backend_helper';

const WaterSourceForm = ({
	dataWaterSource,
	isEdit,
	handleToggleModal,
	isOpen,
	activeTab,
	toggleTab,
	toggleRefetch,
}) => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);

	const selectorWaterSource = createSelector(
		state => state.WaterSource,
		data => ({
			isAdding: data.isAdding,
			isAdded: data.isAdded,
			isUpdating: data.isUpdating,
			isUpdated: data.isUpdated,
			isLoadingList: data.isLoadingList,
			requireCloseModal: data.requireCloseModal
		})
	);
	const {
		isAdding,
		isAdded,
		isUpdating,
		isUpdated,
		isLoadingList,
		requireCloseModal
	} = useSelector(selectorWaterSource);

	// Validation
	const validation = useFormik({
		// Enable reinitialize when initial values need to be changed
		enableReinitialize: true,
		initialValues: {
			name: dataWaterSource?.name || '',
			region_id: dataWaterSource?.region?._id || dataWaterSource?.region_id || '',
			disable: dataWaterSource?.disable || false,
		},
		validationSchema: Yup.object({
			name: Yup.string()
				.required('Campo requerido')
				.test('name-exists-check', 'Fuente de Agua ya existe', async function (value) {
					if (value && (!isEdit || value !== dataWaterSource?.name)) {
						const result = await dispatch(checkWaterSourceExists(value));
						if (result.payload.exists) {
							return this.createError({ message: 'Fuente de Agua ya existe' });
						}
					}
					return true;
				}),
		}),
		validateOnChange: false,
		validateOnBlur: true,
		onSubmit: async values => {
			setIsLoading(true);
			const waterSourceData = {
				...values,
				...(isEdit && { _id: dataWaterSource._id }),
			};

			if (isEdit) {
				await dispatch(updateWaterSource(waterSourceData));
			} else {
				await dispatch(addNewWaterSource(waterSourceData));
			}
			setIsLoading(false);
		},
	});

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
				if (toggleRefetch) {
					setTimeout(() => {
						toggleRefetch();
					}, 100);
				}
			}
		}
	}, [requireCloseModal]);

	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (validation.isValid) setIsLoading(true);
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<Row className='g-3'>
					<Col lg={12}>
						<OInput
							name='name'
							label='Nombre de la Fuente de Agua'
							type='text'
							validation={validation}
							isRequired={true}
							classNameLabel='form-label'
							classNameInput='form-control'
						/>
					</Col>
					<Col lg={12}>
						<OSelect
							key='region_id'
							label='Región'
							id='region_id'
							name='region_id'
							value={validation.values.region_id || ''}
							requestApi={() => getRegionList({})}
							validation={validation}
						/>
					</Col>
				</Row>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={
							isLoading ||
							isAdding ||
							isUpdating
						}
					>
						{
							isLoading ||
								isAdding ||
								isUpdating
								? (
									<i className="label-icon"><Spinner size='sm' /></i>
								)
								: <i className="ri-save-3-line label-icon"></i>
						}
						{isEdit ? 'Editar' : 'Crear'} Fuente de Agua
					</button>
				</div>
			</div>
		</Form>
	);
};

export default WaterSourceForm;
